import { render, staticRenderFns } from "./im-custom-inspect.vue?vue&type=template&id=4eb72f46&scoped=true"
import script from "./im-custom-inspect.vue?vue&type=script&lang=js"
export * from "./im-custom-inspect.vue?vue&type=script&lang=js"
import style0 from "./im-custom-inspect.vue?vue&type=style&index=0&id=4eb72f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb72f46",
  null
  
)

export default component.exports